import React, { useState, useEffect, use } from "react";
import CreateHighwayProposal from '../../Highway/proposal/CreateHighwayProposal';
import {
    MapPin, Building2, Home, Download, Send, Edit, Trash2, Plus, Search, FileText, Globe, Filter, PlusCircle, X, ChevronDown, ChevronUp, Eye,
} from "lucide-react";
import apiService from "../../config";
import { useLanguage } from '../../StoreContext/LanguageContext';

const ViewHighwayProposal = ({ proposalId, projectId, projectName, onBack }) => {

    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [documentUrl, setDocumentUrl] = useState('');
    const { language, translations } = useLanguage();
    // View
    const [viewingProposal, setViewingProposal] = useState(null);

    // State to manage image modal
    const [imageModalUrl, setImageModalUrl] = useState(null);
    const { thumbnailUrl, fullImageUrl } = viewingProposal || {};

    const isImageUrl = (url) => {
        if (!url) return false;
        const ext = url.split('.').pop().toLowerCase();
        return ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(ext);
    };

    const openImageModal = (url) => {
        setImageModalUrl(url);
    };

    const closeImageModal = () => {
        setImageModalUrl(null);
    };

    <img
        src={thumbnailUrl}
        alt="Document Thumbnail"
        className="cursor-pointer"
        onClick={() => openImageModal(fullImageUrl)}
    />


    const handleDownload = () => {
        const printWindow = window.open('', '_blank');

        // Create print content matching the image format
        const createPrintContent = () => {
            return `
        <div class="font-sans pt-3">
            <!-- Header -->
          <div class="text-center mb-5">
            <p style="text-align: center; font-weight: bold;">
                      प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनींचा तपशील
                    </p>
                   <h3 className="text-center font-semibold">
                    प्रकल्प नाव: ${projectName || 'N/A'} | प्रस्ताव नाव/नाव: ${viewingProposal.acquisition_proposal_no}
                  </h3>
                  <p style="text-align: center; font-weight: bold;">
                      मौजे : ${viewingProposal.village_name} , तालुका : ${viewingProposal.taluka_name} ,  जिल्हा : ${viewingProposal.dist_name}
                    </p>
                <h3 className="text-center font-semibold">
                    नमुना "क"
                  </h3>
                <p class="text-xs m-0 leading-tight mb-5 text-center" style="font-weight: bold;">
                    ${projectName || 'N/A'} साठी खाजगी जमिनीच्या भूसंपादचा प्रस्ताव. 
                    ${viewingProposal.acquisition_proposal_no || "N/A"}
                </p>

            </div>
            
            <table class="w-full border-collapse border-2 border-black text-xs">
                <tbody>
                    <!-- १ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">
                            १
                        </td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                            भूसंपादन प्रस्ताव पाठविणाऱ्या अधिका-याचे नाव,पदनाम व पत्ता
                        </td>
                        <td class="border border-black px-4 py-3">
                            <div class="flex flex-col gap-2">
                                <div>
                                    <span class="font-semibold">नाव: </span>
                                    <span class="break-words">${viewingProposal.acquisition_incharge_name || "N/A"}</span>
                                </div>
                                <div>
                                    <span class="font-semibold">पदनाम: </span>
                                    <span class="break-words">${viewingProposal.acquisition_incharge_designation || "-"}</span>
                                </div>
                                <div>
                                    <span class="font-semibold">पत्ता: </span>
                                    <span class="break-words">${viewingProposal.acquisition_incharge_address || "-"}</span>
                                </div>
                            </div>
                        </td>
                    </tr>

                    <!-- २ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">२</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                             भूसंपादन प्रस्ताव सादर करणाऱ्या प्रादेशिक विभागाचे / प्राधिकरणाचे / महामंडळाचे नाव व पत्ता
                        </td>
                        <td class="border border-black px-4 py-3 break-words">
                            ${viewingProposal.acquisition_agency || "-"}
                        </td>
                    </tr>

                    <!-- ३ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">३</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                            मंत्रालयीन स्तरावरील संबंधीत प्रशासकीय विभाग
                        </td>
                        <td class="border border-black px-4 py-3 break-words">
                            ${viewingProposal.acquisition_department || "-"}
                        </td>
                    </tr>

                    <!-- ४ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">४</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                             जमीन कोणत्या कारणासाठी संपादन करून हवी आहे ?
                        </td>
                        <td class="border border-black px-4 py-3 break-words">
                            ${viewingProposal.acquisition_purpose || "-"}
                        </td>
                    </tr>

                    <!-- ५ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">५</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                      जमीन कोणत्या शासन धोरणानुसार/कायद्यानुसार संपादन करून हवी आहे ?
                        </td>
                        <td class="border border-black px-4 py-3 break-words">
                            ${viewingProposal.acquisition_government_policy || "-"}
                        </td>
                    </tr>

                    <!-- ६ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">६</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                           संपादन करावयाच्या जमिनी ज्या क्षेत्रात मोडतात ते गाव, तालुका, जिल्हा.
                        </td>
                        <td class="border border-black px-4 py-3">
                            <div class="flex flex-col gap-2">
                                <div>
                                    <span class="break-words">${viewingProposal.village_name || "-"}, ${viewingProposal.taluka_name || "-"}, ${viewingProposal.dist_name || "-"}</span>
                                </div>
                                
                            </div>
                        </td>
                    </tr>

                    <!-- ७ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">७</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                             संपादन करून हवे असलेले एकूण क्षेत्र
                        </td>
                        <td class="border border-black px-4 py-3">
                            <div class="flex flex-col gap-2">
                                <div>
                                    <span class="font-semibold">एकूण क्षेत्र: </span>
                                        <span class="break-words">${viewingProposal.total_area || "-"}${viewingProposal.area_unit ? ` (${viewingProposal.area_unit})` : ""}</span>

                                </div>
                                <div>
                                    <span class="font-semibold">संपादन क्षेत्र: </span>
                                     <span class="break-words">${viewingProposal.aquired_area || "-"}${viewingProposal.area_unit ? ` (${viewingProposal.area_unit})` : ""}</span>

                                </div>
                            
                            </div>
                        </td>
                    </tr>

                    <!-- ८ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">८</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                         गावनिहाय व गट/सर्व्हे क्र. नुसार आणि संपादन क्षेत्राच्या चतुःसीमा दाखविणारी अनुसूची यासोबत जोडणे आवश्यक आहे, त्याप्रमाणे ती जोडली आहे काय ?(परिशिष्ट ६)
                        </td>
                        <td class="border border-black px-4 py-3">
                            ${viewingProposal.schedule_6_08 ? "होय" : "नाही"}
                        </td>
                    </tr>

                    <!-- ९ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">९</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                          संपादन करावयाच्या क्षेत्राचा चिन्हांकित / साक्षांकित नकाशा प्रस्तावासोबत  जोडणे आवश्यक आहे, त्या प्रमाणे जोडला आहे काय ?
                        </td>
                        <td class="border border-black px-4 py-3">
                            ${viewingProposal.schedule_4_09 ? "होय" : "नाही"}
                        </td>
                    </tr>

                <!-- १० अ -->
<tr class="border border-black">
  <td class="border border-black px-4 py-3 font-medium align-top text-center" rowspan="2">१०</td>
  <td class="border border-black px-4 py-3 font-medium align-top">
    अ. संपादन करावयाच्या क्षेत्राचे ७/१२ चे उतारे किंवा मालमत्ता नोंदवहीतील उतारा प्रस्तावासोबत जोडणे आवश्यक आहे, त्याप्रमाणे जोडण्यात आले आहेत काय ?
  </td>
  <td class="border border-black px-4 py-3">
    ${viewingProposal.extractsextracts_7_12_10 ? "होय" : "नाही"}
  </td>
</tr>

<!-- १० ब -->
<tr class="border border-black">
  <td class="border border-black px-4 py-3 font-medium align-top">
    ब. संपादन करावयाच्या क्षेत्राचे ड्रोन‌द्वारे केलेले छायाचित्रण व KML फाईल जोडण्यात आले आहेत काय ?
  </td>
  <td class="border border-black px-4 py-3">
    ${viewingProposal.drone_kml_file ? "होय" : "नाही"}
  </td>
</tr>


                    <!-- ११ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">११</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                             संपादन करावयाच्या क्षेत्राचे सीमांकन करण्यात आले आहे काय ? असल्यास, सीमांकन प्रमाणपत्र सोबत जोडले आहे काय ?
                        </td>
                        <td class="border border-black px-4 py-3">
                            ${viewingProposal.demarcation_11 ? "होय" : "नाही"}
                        </td>
                    </tr>

                    <!-- १२ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">१२</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                  प्रस्तावामधील नमुद क्षेत्रासाठी यापूर्वीच थेट खरेदी / अन्य कायद्याच्या तरतुदीनुसार भूसंपादन प्रक्रिया सुरू करण्यात आलेली आहे काय ?(संपादनाबाबतचे प्रमाणपत्र)
                        </td>
                        <td class="border border-black px-4 py-3">
                            ${viewingProposal.acquisition_matter_12 ? "होय" : "नाही"}
                        </td>
                    </tr>

                    <!-- १३ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">१३</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                            क्र.१२ चे उत्तर - होय असल्यास, संबंधित भूसंपादन कायदा व प्रस्तावित क्षेत्र नमूद करावे.
                        </td>
                        <td class="border border-black px-4 py-3">
                            <pre class="whitespace-pre-wrap break-words">${viewingProposal.land_acquisition_law_13 || "-"}</pre>
                        </td>
                    </tr>

                    <!-- १४ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">१४</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                            गरजेनुसार आवश्यक तेवढेच क्षेत्र संपादन करून मागितले आहे काय ? त्याबाबत प्रमाणपत्र सोबत जोडावे.
                        </td>
                        <td class="border border-black px-4 py-3">
                            ${viewingProposal.taba_14 ? "होय" : "नाही"}
                        </td>
                    </tr>

                    <!-- १५ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">१५ </td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                            सबंधित प्रयोजनासाठी जवळपास कमी खर्चाची अन्य खाजगी किंवा सरकारी जमीन उपलब्ध आहे काय ? असल्यास, किती अंतरावर आहे ?
                        </td>
                        <td class="border border-black px-4 py-3 break-words">
                            ${viewingProposal.other_govt_land_15 ? "होय" : "नाही"}
                        </td>
                    </tr>

                    <!-- १६ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">१६</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                             संपादन करून मागितलेली जमीन रेल्वे सीमांच्या जवळपास आहे काय? असल्यास, किती अंतरावर आहे ?
                        </td>
                        <td class="border border-black px-4 py-3 break-words">
                            ${viewingProposal.near_railway_boundaries_16 ? "होय" : "नाही"}
                        </td>
                    </tr>

<!-- १७ अ -->
<tr class="border border-black">
  <td class="border border-black px-4 py-3 font-medium align-top text-center" rowspan="2">१७</td>
  <td class="border border-black px-4 py-3 font-medium align-top">
    अ. संपादन क्षेत्रात धार्मिक, प्रार्थना स्थळे, मंदिरे, कब्रस्थान व स्मशानभूमी किंवा पवित्र स्मारके येतात काय ?
  </td>
  <td class="border border-black px-4 py-3">
    ${viewingProposal.religious_places_17 ? "होय" : "नाही"}
  </td>
</tr>

<!-- १७ ब -->
<tr class="border border-black">
  <td class="border border-black px-4 py-3 font-medium align-top">
    ब. संपादन क्षेत्राच्या जवळपास अशा बाबी असल्यास, किती अंतरावर आहेत ?
  </td>
  <td class="border border-black px-4 py-3">
    ${viewingProposal.proximity_distance || "-"}
  </td>
</tr>

                    <!-- १८ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">१८</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                            संपादन करावयाच्या क्षेत्रातून कोणताही सार्वजनिक मार्गाधिकार, जलप्रवाह, जलवाहिनी किंवा जलनिःसारण मार्ग जातो काय ? किंवा खास काही अडथळा निर्माण होतो काय ?
                        </td>
                        <td class="border border-black px-4 py-3 break-words">
                            ${viewingProposal.any_obstruction_18 ? "होय" : "नाही"}
                        </td>
                    </tr>

                    <!-- १९ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">१९</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                             नागरी क्षेत्रात इमारतीमधील खाजगी प्रवेश मार्गाचे किंवा पूर्वापार प्रकाशमार्ग आणि / किंवा हायवेचे मार्ग यावरील कोणत्याही अधिकारात अडथळा येणेचा संभव आहे काय ?
                        </td>
                        <td class="border border-black px-4 py-3 break-words">
                            ${viewingProposal.road_obstruction_19 ? "होय" : "नाही"}
                        </td>
                    </tr>

                    <!-- २०-->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">२०</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                                                                   संपादन क्षेत्राच्या सभोवार इमारत किंवा कारखाना यांना किंवा त्यांची जागा छेदून जाते काय ?

                        </td>
                        <td class="border border-black px-4 py-3">
                            ${viewingProposal.private_buildings_20 ? "होय" : "नाही"}
                        </td>
                    </tr>

                    <!-- २१ -->
                    <tr class="border border-black">
                        <td class="border border-black px-4 py-3 font-medium align-top text-center">२१</td>
                        <td class="border border-black px-4 py-3 font-medium align-top">
                                                                    प्रादेशिक विभाग/प्राधिकरण / महामंडळाच्या प्राधिकृत अधिकाऱ्याचा तपशील

                        </td>
                        <td class="border border-black px-4 py-3">
                            <div class="flex flex-col gap-2">
                                <div>
                                    <span class="font-semibold">नाव :</span>
                                    <span class="break-words">${viewingProposal.acquisition_regional_incharge_name || "-"}</span>
                                </div>
                                <div>
                                    <span class="font-semibold">पदनाम :</span>
                                    <span class="break-words">${viewingProposal.acquisition_regional_incharge_designation || "-"}</span>
                                </div>
                                <div>
                                    <span class="font-semibold">पत्ता :</span>
                                    <span class="break-words">${viewingProposal.acquisition_regional_incharge_address || "-"}</span>
                                </div>
                                
                                <div>
                                    <span class="font-semibold">भ्रमणध्वनी :</span>
                                    <span class="break-words">${viewingProposal.acquisition_regional_incharge_contact || "-"}</span>
                                </div>
                                <div>
                                    <span class="font-semibold">कार्यालयीन दुरध्वनी :</span>
                                    <span class="break-words">${viewingProposal.acquisition_regional_incharge_office_contact || "-"}</span>
                                </div>
                                <div>
                                    <span class="font-semibold">ईमेल :</span>
                                    <span class="break-words">${viewingProposal.acquisition_regional_incharge_email || "-"}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div style="margin-top: 40px; display: flex; justify-content: space-between; font-size: 12px;">
        <div style="text-align: center; width: 45%;">
          
          <div style="margin-top:60px">
            <div>${viewingProposal.acquisition_incharge_name || ''}</div>
            <div>${viewingProposal.acquisition_incharge_designation || ''}</div>           
          </div>
        </div>
        <div style="text-align: center; width: 45%;">
         
          <div style="margin-top:60px">
            <div>${viewingProposal.acquisition_regional_incharge_name || ''}</div>
            <div>${viewingProposal.acquisition_regional_incharge_designation || ''}</div>
          </div>
        </div>
      </div>
    </div>
  `;
        };
        const printHTML = `
    <!DOCTYPE html>
    <html>
    <head>
<title>नमुना "क" - ${projectName || ''} - ${viewingProposal.proposalId || ''}</title>      <meta charset="UTF-8">
      <style>
        @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
        }
        table {
          page-break-inside: auto;
        }
        tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }
        .border {
          border: 1px solid black;
        }
        .border-2 {
          border-width: 2px;
        }
        .border-black {
          border-color: black;
        }
        .border-collapse {
          border-collapse: collapse;
        }
        .w-full {
          width: 100%;
        }
        .text-xs {
          font-size: 0.75rem;
        }
        .text-sm {
          font-size: 0.875rem;
        }
        .text-base {
          font-size: 1rem;
        }
        .font-bold {
          font-weight: bold;
        }
        .font-medium {
          font-weight: 500;
        }
        .font-semibold {
          font-weight: 600;
        }
        .px-4 {
          padding-left: 1rem;
          padding-right: 1rem;
        }
        .py-3 {
          padding-top: 0.75rem;
          padding-bottom: 0.75rem;
        }
        .mb-2 {
          margin-bottom: 0.5rem;
        }
        .mb-5 {
          margin-bottom: 1.25rem;
        }
        .pt-4 {
          padding-top: 1rem;
        }
        .text-center {
          text-align: center;
        }
        .align-top {
          vertical-align: top;
        }
        .break-words {
          word-wrap: break-word;
        }
        .leading-tight {
          line-height: 1.25;
        }
        .m-0 {
          margin: 0;
        }
        .flex {
          display: flex;
        }
        .flex-col {
          flex-direction: column;
        }
        .gap-2 {
          gap: 0.5rem;
        }
        .whitespace-pre-wrap {
          white-space: pre-wrap;
        }
        @media print {
          body { margin: 0; }
          button { display: none !important; }
          input[type="file"] { display: none !important; }
          select { display: none !important; }
          input { display: none !important; }
          textarea { display: none !important; }
        }
      </style>
    </head>
    <body>
      ${createPrintContent()}
    </body>
    </html>
  `;

        // Write the HTML and trigger print
        printWindow.document.write(printHTML);
        printWindow.document.close();
        printWindow.focus();

        // Add a small delay before printing to ensure content is loaded
        setTimeout(() => {
            printWindow.print();
        }, 500);
    };

    // Handle document view
    const handleViewDocument = (fileOrUrl) => {
        console.log("🔎 handleViewDocument called with:", fileOrUrl);

        if (!fileOrUrl) {
            console.warn("⚠️ No fileOrUrl passed, nothing to show.");
            return;
        }

        if (fileOrUrl instanceof File) {
            console.log("📂 Detected a File object:", fileOrUrl.name);
            const url = URL.createObjectURL(fileOrUrl);
            console.log("👉 Created blob URL:", url);
            setDocumentUrl(url);
        } else {
            console.log("🌐 Detected a string URL:", fileOrUrl);
            setDocumentUrl(fileOrUrl);
        }

        setShowModal(true);
        console.log("✅ Modal state set to true");
    };



    useEffect(() => {
        const handleViewClick = async () => {
            if (!projectId || !proposalId) {
                alert("No project selected");
                return;
            }

            console.log("Fetching proposal details for projectId:", projectId, "and proposalId:", proposalId);

            setLoading(true);
            try {
                const result = await apiService.getHighwayProposalById(projectId, proposalId);
                if (result && result.status === 200) {
                    const proposalsData = Array.isArray(result.data) ? result.data[0] : result.data;
                    console.log("Fetched proposal data:", proposalsData);
                    setViewingProposal(proposalsData);
                } else {
                    setViewingProposal(null);
                }
            } catch (error) {
                setViewingProposal(null);
            } finally {
                setLoading(false);
            }
        };

        handleViewClick();
    }, [projectId, proposalId]); // runs whenever IDs change

    return (
        <>
            {viewingProposal && (
                <div className="max-w-4xl mx-auto">
                    {/* Print Button - Hidden during print */}
                    <div className="mb-4 print:hidden">
                        <button
                            onClick={handleDownload}
                            className="bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600"
                        >
                            Print
                        </button>
                    </div>
                    <div className=" font-sans pt-4">

                        {/* Header */}
                        <p className="text-center font-semibold mb-2">
                            प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनींचा तपशील
                        </p>
                        <h3 className="text-center font-semibold mb-2">
                            प्रकल्प नाव: {projectName || 'N/A'} | प्रस्ताव नाव/नाव: {viewingProposal.acquisition_proposal_no}
                        </h3>
                        <p className="text-center font-semibold mb-2">
                            मौजे : {viewingProposal.village_name} , तालुका : {viewingProposal.taluka_name} ,  जिल्हा : {viewingProposal.dist_name}
                        </p>
                        <div className="text-center mb-5">
                            <h2 className="mb-4 text-2xl font-bold">
                                नमुना "क"
                            </h2>
                            <p class="text-xs m-0 leading-tight mb-5 text-center font-semibold">
                                {projectName || 'N/A'} साठी खाजगी जमिनीच्या भूसंपादचा प्रस्ताव {viewingProposal.acquisition_proposal_no}
                            </p>
                        </div>
                        <table className="w-full border-collapse border-2 border-black text-base">
                            {/* <colgroup>
                            <col style={{ width: '5%' }} />
                            <col style={{ width: '55%' }} />
                            <col style={{ width: '15%' }} />
                        </colgroup> */}

                            <tbody>
                                {/* १ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">
                                        १
                                    </td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        भूसंपादन प्रस्ताव पाठविणाऱ्या अधिका-याचे नाव,पदनाम व पत्ता
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex flex-col gap-2">
                                            <div>
                                                <span className="font-semibold">नाव: </span>
                                                <span className="break-words">{viewingProposal.acquisition_incharge_name || "N/A"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">पदनाम/संपादन संस्थेचे नाव: </span>
                                                <span className="break-words">{viewingProposal.acquisition_incharge_designation || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">पत्ता: </span>
                                                <span className="break-words">{viewingProposal.acquisition_incharge_address || "-"}</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                {/* २ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">२</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        भूसंपादन प्रस्ताव सादर करणाऱ्या प्रादेशिक विभागाचे / प्राधिकरणाचे / महामंडळाचे नाव व पत्ता                                    </td>
                                    <td className="border border-black px-4 py-3 break-words">
                                        {viewingProposal.acquisition_agency || "-"}
                                    </td>
                                </tr>

                                {/* ३ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">३</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        मंत्रालयीन स्तरावरील संबंधीत प्रशासकीय विभाग
                                    </td>
                                    <td className="border border-black px-4 py-3 break-words">
                                        {viewingProposal.acquisition_department || "-"}
                                    </td>
                                </tr>

                                {/* ४ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">४</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        जमीन कोणत्या कारणासाठी संपादन करून हवी आहे ?
                                    </td>
                                    <td className="border border-black px-4 py-3 break-words">
                                        {viewingProposal.acquisition_purpose || "-"}
                                    </td>
                                </tr>

                                {/* ५ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">५</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        जमीन कोणत्या शासन धोरणानुसार/कायद्यानुसार संपादन करून हवी आहे ?
                                    </td>
                                    <td className="border border-black px-4 py-3 break-words">
                                        {viewingProposal.acquisition_government_policy || "-"}
                                    </td>
                                </tr>

                                {/* ६ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">६</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करावयाच्या जमिनी ज्या क्षेत्रात मोडतात ते गाव, तालुका, जिल्हा.
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex flex-col gap-2">
                                            <div>
                                                <span className="font-semibold">जिल्हा: </span>
                                                <span className="break-words">{viewingProposal.dist_name || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">तालुका: </span>
                                                <span className="break-words">{viewingProposal.taluka_name || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">गाव: </span>
                                                <span className="break-words">{viewingProposal.village_name || "-"}</span>
                                            </div>
                                        </div>
                                    </td>

                                </tr>

                                {/* ७ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">७</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करून हवे असलेले एकूण क्षेत्र
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex flex-col gap-2">
                                            <div>
                                                <span className="font-semibold">एकूण क्षेत्र: </span>
                                                <span className="break-words">{viewingProposal.total_area || "-"}({viewingProposal.area_unit || "-"})</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">संपादन क्षेत्र: </span>
                                                <span className="break-words">{viewingProposal.aquired_area || "-"}({viewingProposal.area_unit || "-"})</span>
                                            </div>
                                            {/* <div>
                                                <span className="font-semibold">क्षेत्रफळ युनिट: </span>
                                                <span className="break-words">{viewingProposal.area_unit || "-"}</span>
                                            </div> */}
                                        </div>
                                    </td>
                                </tr>

                                {/* ८ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">८</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        गावनिहाय व गट/सर्व्हे क्र. नुसार आणि संपादन क्षेत्राच्या चतुःसीमा दाखविणारी अनुसूची यासोबत जोडणे आवश्यक आहे, त्याप्रमाणे ती जोडली आहे काय ?(परिशिष्ट ६)
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.schedule_6_08 ? "होय" : "नाही"}</span>
                                            {viewingProposal.schedule_6_08_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.schedule_6_08_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* ९ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">९</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करावयाच्या क्षेत्राचा चिन्हांकित / साक्षांकित नकाशा प्रस्तावासोबत  जोडणे आवश्यक आहे, त्या प्रमाणे जोडला आहे काय ? भूमिअभिलेख विभागाकडील गावाचे नकाशे दोन प्रतीत सादर केले आहे काय ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.schedule_4_09 ? "होय" : "नाही"}</span>
                                            {viewingProposal.schedule_4_09_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.schedule_4_09_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १०
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१०</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        अ. संपादन करावयाच्या क्षेत्राचे ७/१२ चे उतारे किंवा मालमत्ता नोंदवहीतील उतारा प्रस्तावासोबत जोडणे आवश्यक आहे, त्याप्रमाणे जोडण्यात आले आहेत काय ?
                                        ब.संपादन करावयाच्या क्षेत्राचे ड्रोन‌द्वारे केलेले छायाचित्रण व KML फाईल जोडण्यात आले आहेत काय ?

                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.extractsextracts_7_12_10 ? "होय" : "नाही"}</span>
                                            {viewingProposal.extractsextracts_7_12_10_file ? (
                                                <button
                                                    onClick={() => window.open(viewingProposal.extractsextracts_7_12_10_file, '_blank')}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr> */}
                                {/* १० अ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center" rowSpan={2}>१०</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        अ. संपादन करावयाच्या क्षेत्राचे ७/१२ चे उतारे किंवा मालमत्ता नोंदवहीतील उतारा प्रस्तावासोबत जोडणे आवश्यक आहे, त्याप्रमाणे जोडण्यात आले आहेत काय ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.extractsextracts_7_12_10 ? "होय" : "नाही"}</span>
                                            {viewingProposal.extractsextracts_7_12_10_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.extractsextracts_7_12_10_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १० ब */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        ब. संपादन करावयाच्या क्षेत्राचे ड्रोन‌द्वारे केलेले छायाचित्रण व KML फाईल जोडण्यात आले आहेत काय ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.drone_kml ? "होय" : "नाही"}</span>
                                            {viewingProposal.drone_kml_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.drone_kml_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* ११ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">११</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करावयाच्या क्षेत्राचे सीमांकन करण्यात आले आहे काय ? असल्यास, सीमांकन प्रमाणपत्र सोबत जोडले आहे काय ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.demarcation_11 ? "होय" : "नाही"}</span>
                                            {viewingProposal.demarcation_11_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.demarcation_11_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १२ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१२</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        प्रस्तावामधील नमुद क्षेत्रासाठी यापूर्वीच थेट खरेदी / अन्य कायद्याच्या तरतुदीनुसार भूसंपादन प्रक्रिया सुरू करण्यात आलेली आहे काय ?(संपादनाबाबतचे प्रमाणपत्र)
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.acquisition_matter_12 ? "होय" : "नाही"}</span>
                                            {viewingProposal.acquisition_matter_12_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.acquisition_matter_12_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १३ */}
                                <tr className="border border-black hover:bg-black-50 align-top">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१३</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        क्र.१२ चे उत्तर - होय असल्यास, संबंधित भूसंपादन कायदा व प्रस्तावित क्षेत्र नमूद करावे.
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <pre className="whitespace-pre-wrap break-words text-sm">{viewingProposal.land_acquisition_law_13 || "-"}</pre>
                                    </td>
                                </tr>

                                {/* १४ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१४</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        गरजेनुसार आवश्यक तेवढेच क्षेत्र संपादन करून मागितले आहे काय ? त्याबाबत प्रमाणपत्र सोबत जोडावे.
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.taba_14 ? "होय" : "नाही"}</span>
                                            {viewingProposal.taba_14_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.taba_14_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १५ */}
                                {/* other_govt_land_15 other_govt_land_15_file */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१५</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        सबंधित प्रयोजनासाठी जवळपास कमी खर्चाची अन्य खाजगी किंवा सरकारी जमीन उपलब्ध आहे काय ? असल्यास, किती अंतरावर आहे ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.other_govt_land_15 ? "होय" : "नाही"}</span>
                                            {viewingProposal.other_govt_land_15_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.other_govt_land_15_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १६ */}
                                {/* near_railway_boundaries_16  near_railway_boundaries_16_file */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१६</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करून मागितलेली जमीन रेल्वे सीमांच्या जवळपास आहे काय? असल्यास, किती अंतरावर आहे ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.near_railway_boundaries_16 ? "होय" : "नाही"}</span>
                                            {viewingProposal.near_railway_boundaries_16_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.near_railway_boundaries_16_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १७ */}
                                {/* religious_places_17 religious_places_17_file */}
                                {/* <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१७</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        अ.संपादन क्षेत्रात धार्मिक, प्रार्थना स्थळे, मंदिरे, कब्रस्थान व स्मशानभूमी किंवा पवित्र स्मारके येतात काय ?
                                        ब.संपादन क्षेत्राच्या जवळपास अशा बाबी असल्यास, किती अंतरावर आहेत ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.religious_places_17 ? "होय" : "नाही"}</span>
                                            {viewingProposal.religious_places_17_file ? (
                                                <button
                                                    onClick={() => window.open(viewingProposal.religious_places_17_file, '_blank')}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr> */}

                                {/* १७ */}
                                {/* First question row */}
                                <tr className="border border-black hover:bg-black-50">
                                    {/* Number column spanning both rows */}
                                    <td
                                        className="border border-black px-4 py-3 font-medium align-top text-center"
                                        rowSpan={2}
                                    >
                                        १७
                                    </td>

                                    {/* अ. question */}
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        अ. संपादन क्षेत्रात धार्मिक, प्रार्थना स्थळे, मंदिरे, कब्रस्थान व स्मशानभूमी किंवा पवित्र स्मारके येतात काय ?
                                    </td>

                                    {/* Answer column spanning both rows */}
                                    <td className="border border-black px-4 py-3">
                                        {/* अ. answer */}
                                        <div className="flex items-center gap-3 mb-2">
                                            <span>{viewingProposal.religious_places_17 ? "होय" : "नाही"}</span>
                                            {viewingProposal.religious_places_17_file ? (
                                                <button
                                                    onClick={() =>
                                                        handleViewDocument(viewingProposal.religious_places_17_file)
                                                    }
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* Second question row */}
                                <tr className="border border-black hover:bg-black-50">
                                    {/* ब. question */}
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        ब. संपादन क्षेत्राच्या जवळपास अशा बाबी असल्यास, किती अंतरावर आहेत ?
                                    </td>

                                    {/* ब. answer */}
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.proximity_distance || "-"}</span>
                                            {viewingProposal.proximity_distance_file ? (
                                                <button
                                                    onClick={() =>
                                                        handleViewDocument(viewingProposal.proximity_distance_file)
                                                    }
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>


                                {/* १८ */}
                                {/* any_obstruction_18 any_obstruction_18_file */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१८</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन करावयाच्या क्षेत्रातून कोणताही सार्वजनिक मार्गाधिकार, जलप्रवाह, जलवाहिनी किंवा जलनिःसारण मार्ग जातो काय ? किंवा खास काही अडथळा निर्माण होतो काय ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.any_obstruction_18 ? "होय" : "नाही"}</span>
                                            {viewingProposal.any_obstruction_18_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.any_obstruction_18_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* १९ */}
                                {/* road_obstruction_19  road_obstruction_19_file */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">१९</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        नागरी क्षेत्रात इमारतीमधील खाजगी प्रवेश मार्गाचे किंवा पूर्वापार प्रकाशमार्ग आणि / किंवा हायवेचे मार्ग यावरील कोणत्याही अधिकारात अडथळा येणेचा संभव आहे काय ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.road_obstruction_19 ? "होय" : "नाही"}</span>
                                            {viewingProposal.road_obstruction_19_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.road_obstruction_19_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {/* २० */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">२०</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        संपादन क्षेत्राच्या सभोवार इमारत किंवा कारखाना यांना किंवा त्यांची जागा छेदून जाते काय ?
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex items-center gap-3">
                                            <span>{viewingProposal.private_buildings_20 ? "होय" : "नाही"}</span>
                                            {viewingProposal.private_buildings_20_file ? (
                                                <button
                                                    onClick={() => handleViewDocument(viewingProposal.private_buildings_20_file)}
                                                    className="bg-blue-500 text-white px-3 py-1 rounded text-xs hover:bg-blue-600"
                                                >
                                                    View
                                                </button>
                                            ) : (
                                                <span className="text-black-500 text-base"></span>
                                            )}
                                        </div>
                                    </td>
                                </tr>



                                {/* २१ */}
                                <tr className="border border-black hover:bg-black-50">
                                    <td className="border border-black px-4 py-3 font-medium align-top text-center">२४</td>
                                    <td className="border border-black px-4 py-3 font-medium align-top">
                                        प्रादेशिक विभाग/प्राधिकरण / महामंडळाच्या प्राधिकृत अधिकाऱ्याचा तपशील
                                    </td>
                                    <td className="border border-black px-4 py-3">
                                        <div className="flex flex-col gap-2">
                                            <div>
                                                <span className="font-semibold">नाव :</span>{" "}
                                                <span className="break-words">{viewingProposal.acquisition_regional_incharge_name || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">पदनाम :</span>{" "}
                                                <span className="break-words">{viewingProposal.acquisition_regional_incharge_designation || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">पत्ता :</span>{" "}
                                                <span className="break-words">{viewingProposal.acquisition_regional_incharge_address || "-"}</span>
                                            </div>

                                            <div>
                                                <span className="font-semibold">भ्रमणध्वनी क्र.:</span>{" "}
                                                <span className="break-words">{viewingProposal.acquisition_regional_incharge_contact || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">कार्यालयीन दुरध्वनी क्र.:</span>{" "}
                                                <span className="break-words">{viewingProposal.acquisition_regional_incharge_office_contact || "-"}</span>
                                            </div>
                                            <div>
                                                <span className="font-semibold">ई-मेल :</span>{" "}
                                                <span className="break-words">{viewingProposal.acquisition_regional_incharge_email || "-"}</span>
                                            </div>
                                        </div>
                                    </td>

                                </tr>




                            </tbody>
                        </table>
                        {/* Footer Signatures */}
                        <div style={{
                            marginTop: "40px",
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "12px"
                        }}>
                            <div style={{ textAlign: "center", width: "45%" }}>
                                {/* <div style={{ height: "60px", borderBottom: "1px solid #000", marginBottom: "5px" }}></div> */}
                                <div style={{ marginTop: "60px" }}>
                                    <div >{viewingProposal.acquisition_incharge_name || ''}</div>
                                    <div >{viewingProposal.acquisition_incharge_designation || ''}</div>
                                    {/* <div>(एरक्राझावत्र)</div>
                                    <div>कार्यकारी अधिकारी</div>
                                    <div>जिल्हा जग्याला सेवा उपविभाग क्र.२</div>
                                    <div>खादान</div>
                                    <div>"क" र)</div> */}
                                </div>
                            </div>
                            <div style={{ textAlign: "center", width: "45%" }}>
                                {/* <div style={{ height: "60px", borderBottom: "1px solid #000", marginBottom: "5px" }}></div> */}
                                <div style={{ marginTop: "60px" }}>
                                    <div>{viewingProposal.acquisition_regional_incharge_name || ''}</div>
                                    <div>{viewingProposal.acquisition_regional_incharge_designation || ''}</div>
                                    {/* <div>कार्यकारी अधिकारी</div>
                <div>जिल्हा उग्रा सेवा सैवभाग</div>
                <div>२९. खादान</div> */}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )}

            {/* Image Modal */}
            {imageModalUrl && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-60"
                    onClick={closeImageModal}
                >
                    <div
                        className="relative bg-white rounded-lg shadow-2xl max-w-[95vw] max-h-[95vh] overflow-hidden"
                        onClick={e => e.stopPropagation()}
                    >
                        <button
                            onClick={closeImageModal}
                            className="absolute top-3 right-3 z-10 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-800 hover:text-red-600 rounded-full w-10 h-10 flex items-center justify-center font-bold text-xl transition-all duration-200 shadow-lg"
                            aria-label="Close image"
                        >
                            ×
                        </button>

                        <div className="p-4">
                            <img
                                src={imageModalUrl}
                                alt="Document View"
                                className="max-w-full max-h-[85vh] object-contain mx-auto block rounded"
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Document Viewer Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto mt-12">
                        {/* Header */}
                        <div className="flex justify-between items-center p-4">
                            <h3 className="text-xl font-semibold text-gray-800">
                                {translations[language]?.DocumentPreview}
                            </h3>
                            <button
                                onClick={() => {
                                    setShowModal(false);
                                    if (documentUrl?.startsWith("blob:")) {
                                        URL.revokeObjectURL(documentUrl);
                                    }
                                }}
                                className="text-gray-400 hover:text-gray-700 text-2xl font-bold"
                            >
                                ×
                            </button>
                        </div>

                        {/* Document Viewer */}
                        {/* {console.log("🖼 Rendering iframe with src:", documentUrl)} */}
                        <iframe
                            src={documentUrl}
                            className="w-full h-[80vh] rounded border border-gray-300"
                            title="Document Preview"
                        />
                    </div>
                </div>
            )}

        </>
    );
}
export default ViewHighwayProposal;